module.exports = {"cookies":"Cookies","help":"Ajuda","privacy":"Privacidade","signInButtonText":"Fazer logon com uma Adobe ID","termsOfUse":"Termos de uso","updated":"ATUALIZADO"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpLogin/__localization__/ExpLogin/pt_br.json
// module id = 950
// module chunks = 0